export const addTestId = (id: string) => {
  return { 'data-testid': id } // HTML attribute name 'data-testid' is used by the Playwright testing library
}
